import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Cog6ToothIcon } from '@heroicons/react/24/outline';
import { Budget } from '../types/budget';
import { BudgetSettingsDialog } from './BudgetSettingsDialog';

interface BudgetSettingsButtonProps {
  budget: Budget & { id: number };
  showText?: boolean;
  className?: string;
}

export const BudgetSettingsButton: React.FC<BudgetSettingsButtonProps> = ({
  budget,
  showText = false,
  className = '',
}) => {
  const { t } = useTranslation();
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsSettingsOpen(true)}
        className={`inline-flex items-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600 ${className}`}
      >
        <Cog6ToothIcon className="h-5 w-5" aria-hidden="true" />
        {showText && <span className="ml-2">{t('budget.settings.title')}</span>}
      </button>

      <BudgetSettingsDialog
        budget={budget}
        isOpen={isSettingsOpen}
        onClose={() => setIsSettingsOpen(false)}
      />
    </>
  );
};
